import React from 'react';
import { ListItem, ListItemText, Menu } from '@material-ui/core';
import MoreVertIcon from '@material-ui/icons/MoreVert';

export type ActionType = 'EDIT' | 'DELETE' | 'MOVE_UP' | 'MOVE_DOWN';
interface Props {
  showOrderActions?: boolean;
  showDeleteActions?: boolean;
  onAction: (action: ActionType) => void;
}

const ActionMenu: React.FC<Props> = (props) => {
  const { showDeleteActions = false, showOrderActions = false, onAction } = props;
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const handleMenuOpen = (event: React.MouseEvent<any>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleActionTaken = (action: ActionType) => {
    handleMenuClose();
    onAction(action);
  };

  return (
    <>
      <MoreVertIcon onClick={handleMenuOpen} />
      <Menu
        id="account-menu"
        anchorEl={anchorEl}
        getContentAnchorEl={null}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        transformOrigin={{ vertical: 'center', horizontal: 'left' }}
      >
        <ListItem button onClick={() => handleActionTaken('EDIT')}>
          <ListItemText primary="Edit" />
        </ListItem>
        {showOrderActions && (
          <ListItem button onClick={() => handleActionTaken('MOVE_UP')}>
            <ListItemText primary="Move Up" />
          </ListItem>
        )}
        {showOrderActions && (
          <ListItem button onClick={() => handleActionTaken('MOVE_DOWN')}>
            <ListItemText primary="Move Down" />
          </ListItem>
        )}
        {showDeleteActions && (
          <ListItem button onClick={() => handleActionTaken('DELETE')}>
            <ListItemText primary="Delete" />
          </ListItem>
        )}
      </Menu>
    </>
  );
};

export default ActionMenu;
